export default __webpack_public_path__ + "static/media/arrow-down-circle.755b6247.svg";